var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSayshopLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172.7 135.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f36b24;}.cls-2{fill:#fff;}.cls-3{fill:none;}.cls-4{fill:#24255c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.8,19.4h-7.2a12.2,12.2,0,1,0-24.4,0H88a19.4,19.4,0,1,1,38.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.8,84.3H91.2A14.76662,14.76662,0,0,1,76.4,69.5V22.1h62.2V69.5A14.89555,14.89555,0,0,1,123.8,84.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122,87.9H92.9A20.10118,20.10118,0,0,1,72.8,67.8V22.1a3.585,3.585,0,0,1,3.6-3.6h62.2a3.585,3.585,0,0,1,3.6,3.6V67.8A20.25163,20.25163,0,0,1,122,87.9ZM80,25.7V67.8A12.93146,12.93146,0,0,0,92.9,80.7H122a12.93146,12.93146,0,0,0,12.9-12.9V25.7Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 41.3,
    y1: 31.3,
    x2: 34.6,
    y2: 31.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.3,34.9H34.6a3.6,3.6,0,0,1,0-7.2h6.7a3.6,3.6,0,0,1,0,7.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.4,
    y1: 31.3,
    x2: 52.1,
    y2: 31.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.4,34.9H52.2a3.6,3.6,0,0,1,0-7.2H76.4a3.6,3.6,0,1,1,0,7.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.4,
    y1: 48.8,
    x2: 58.4,
    y2: 48.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.4,52.4H58.5a3.6,3.6,0,0,1,0-7.2H76.4a3.6,3.6,0,1,1,0,7.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.4,
    y1: 66.3,
    x2: 67.4,
    y2: 66.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.4,69.9h-9a3.6,3.6,0,0,1,0-7.2h9a3.6,3.6,0,1,1,0,7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.7,52.4a3.408,3.408,0,0,1-2.5-1.1,3.58052,3.58052,0,0,1-1.1-2.5,1.70178,1.70178,0,0,1,.1-.7,1.85411,1.85411,0,0,1,.2-.7l.3-.6a2.18156,2.18156,0,0,1,.4-.5,3.78464,3.78464,0,0,1,3.2-1,1.8539,1.8539,0,0,1,.7.2l.6.3a2.18161,2.18161,0,0,1,.5.4,1.75575,1.75575,0,0,1,.4.5l.3.6a1.44542,1.44542,0,0,1,.2.7c0,.2.1.5.1.7a1.70173,1.70173,0,0,1-.1.7,1.85421,1.85421,0,0,1-.2.7l-.3.6a2.18134,2.18134,0,0,1-.4.5,1.75544,1.75544,0,0,1-.5.4l-.6.3a1.44516,1.44516,0,0,1-.7.2A.59887.59887,0,0,1,47.7,52.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.3,53.2l2.1-2.1,3.3-3.3a1.53549,1.53549,0,0,1,1.3-.5c6.1-.1,9.8,3.8,10.7,8.2,1.5,6.9-3.4,12.9-9.8,13-7.4.1-14.7,0-22.1,0a1.75945,1.75945,0,0,1-.6-.1,5.545,5.545,0,0,1,.6-.8c1.4-1.4,2.8-2.7,4.2-4.2a2.36417,2.36417,0,0,1,1.9-.8h15.2A4.92912,4.92912,0,0,0,118,61a4.81085,4.81085,0,0,0-1.3-7.5,8.73386,8.73386,0,0,0-2.2-.5C112.1,53.2,109.9,53.2,107.3,53.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.8,37.8a20.89957,20.89957,0,0,1-1.5,1.5L118,42.6a2.42754,2.42754,0,0,1-2.1.9H100a4.59389,4.59389,0,0,0-4.1,4.7,4.55474,4.55474,0,0,0,4,4.9,21.74982,21.74982,0,0,0,2.6.1h4.8c-.3.4-.4.6-.6.7-1.5,1.5-3,2.9-4.4,4.4a2.19322,2.19322,0,0,1-1.7.7A10.58452,10.58452,0,0,1,90.1,48.4a10.44623,10.44623,0,0,1,7.4-10.2,12.58838,12.58838,0,0,1,2.7-.4h21.7C122,37.7,122.2,37.8,122.8,37.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,132.4l2.2-5a15.00774,15.00774,0,0,0,7.9,2.4c2.8,0,3.9-.8,3.9-2,0-3.8-13.6-1-13.6-9.9,0-4.3,3.5-7.8,10.6-7.8a17.77755,17.77755,0,0,1,8.7,2.1l-2.1,5a14.60127,14.60127,0,0,0-6.6-1.8c-2.8,0-3.9,1-3.9,2.2,0,3.7,13.6.9,13.6,9.8,0,4.2-3.5,7.7-10.6,7.7C6.2,135,2.2,134,0,132.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.9,129.9H29.7l-1.9,4.7H20.9l10.6-24h6.7l10.6,24h-7Zm-2-5-3.1-7.7-3.1,7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62,126v8.6H55.2v-8.7l-9.1-15.3h7.2l5.7,9.5,5.7-9.5h6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.7,132.4l2.2-5a15.00779,15.00779,0,0,0,7.9,2.4c2.8,0,3.9-.8,3.9-2,0-3.8-13.6-1-13.6-9.9,0-4.3,3.5-7.8,10.6-7.8a17.77752,17.77752,0,0,1,8.7,2.1l-2.1,5a14.60131,14.60131,0,0,0-6.6-1.8c-2.8,0-3.9,1-3.9,2.2,0,3.7,13.6.9,13.6,9.8,0,4.2-3.5,7.7-10.6,7.7C76.9,135,73,134,70.7,132.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.4,110.6v24h-6.8v-9.3h-9.2v9.3H94.6v-24h6.8v9h9.2v-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.9,122.6c0-7.2,5.6-12.5,13.3-12.5s13.3,5.3,13.3,12.5-5.6,12.5-13.3,12.5C126.6,135,120.9,129.8,120.9,122.6Zm19.8,0c0-4.1-2.8-6.8-6.5-6.8s-6.5,2.7-6.5,6.8,2.8,6.8,6.5,6.8S140.7,126.7,140.7,122.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.7,119.5c0,5.4-4.1,8.8-10.6,8.8h-4.2v6.3h-6.8v-24h11C168.6,110.6,172.7,114,172.7,119.5Zm-6.8,0c0-2.2-1.4-3.5-4.2-3.5h-3.8v7h3.8C164.4,123,165.9,121.7,165.9,119.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSayshopLogo);
export default __webpack_public_path__ + "static/media/sayshop_logo.1dd60875fe5bc4bc16776f296aa7e799.svg";
export { ForwardRef as ReactComponent };